<template>
  <div id="app">
    <Header
    :loadHome='loadHome'
    />
    <AboutWeb v-if="loadHomePage==true"/>
    <Products v-if="loadHomePage==true"
    :myproducts="ProductDetails"
    />
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Products from './components/Products.vue'
import AboutWeb from './components/AboutWeb.vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

export default {
  name: 'App',
  components: {
    Header,
    Products,
    AboutWeb
  },
  data(){
    return{
      loadHomePage:false,
      ProductDetails:'',
    }
  },
  methods:{
    loadHome:function(value){
      
        
        this.loadHomePage=value;
     
    }
  }
}
</script>

<style>
html,body
{
    width: 100%;
    height: 100%;
    margin: 0px;
    padding: 0px;
    overflow-x: hidden; 
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 50px;
}
</style>
